import { makeStyles } from "@material-ui/core"

export default makeStyles(() => ({
    iconButton: {
        padding: 4
    }
}))
